<div>
  <figure class="highcharts-figure">
    <div id="pie"></div>
    <p class="highcharts-description" style="text-align: justify">
      {{ "dashboard.variable-pie-description" | translate }}
    </p>
  </figure>
</div>
